package com.ervasstudio.tracoemovimento.model

import kotlinx.serialization.Serializable

@Serializable
data class VisitData(
    val visita: String,
 // Podes passar a data ou deixar que a API preencha no backend
)